"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdleTimeout = void 0;
const platform_sdk_1 = require("@pureweb/platform-sdk");
const react_1 = __importStar(require("react"));
const react_idle_timer_1 = __importDefault(require("react-idle-timer"));
const react_modal_1 = __importDefault(require("react-modal"));
const modalStyle = {
    overlay: {
        position: 'fixed',
        top: '0px',
        left: '0px',
        right: '0px',
        bottom: '0px',
        backgroundColor: 'rgba(0,0,0,0.9)',
        zIndex: '999'
    },
    content: {
        fontFamily: 'Lato, sans-serif',
        color: 'white',
        position: 'absolute',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        background: 'rgb(26,26,26)',
        overflow: 'auto',
        borderRadius: '10px',
        outline: 'none',
        padding: '40px',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        boxShadow: '0px 0px 61px 9px rgba(0, 0, 0, 0.9)'
    }
};
// Responsible for opening a modal after a user has been idle for a given amount of time
exports.IdleTimeout = (props) => {
    const [modalIsOpen, setIsOpen] = react_1.useState(false);
    const [counting, setCounting] = react_1.useState(false);
    const [counter, setCounter] = react_1.useState(0);
    const [hardTimeout, setHardTimeout] = react_1.useState(null);
    const idleTimerRef = react_1.useRef(null);
    // Only run idle timer when client is connected
    react_1.useEffect(() => {
        var _a, _b, _c;
        if (isConnected()) {
            (_a = idleTimerRef.current) === null || _a === void 0 ? void 0 : _a.resume();
            (_b = idleTimerRef.current) === null || _b === void 0 ? void 0 : _b.reset();
            startHardTimeout();
        }
        else {
            (_c = idleTimerRef.current) === null || _c === void 0 ? void 0 : _c.pause();
            stopHardTimeout();
        }
    }, [props.Status]);
    // Count down timer while modal is open
    react_1.useEffect(() => {
        if (counting) {
            if (counter > 0) {
                setTimeout(() => setCounter(counter - 1), 1000);
            }
            else {
                handleExit();
            }
        }
    }, [counting, counter]);
    const startHardTimeout = () => {
        if (props.HardExitThreshold) {
            setHardTimeout(setTimeout(() => handleExit(), props.HardExitThreshold * 1000));
        }
    };
    const stopHardTimeout = () => {
        if (hardTimeout != null) {
            clearTimeout(hardTimeout);
        }
    };
    const onIdle = () => {
        if (!modalIsOpen) {
            handleOpenModal();
        }
    };
    const handleOpenModal = () => {
        if (props.WarningCallback) {
            props.WarningCallback();
        }
        startTimer();
        setIsOpen(true);
    };
    const handleCloseModal = () => {
        if (isConnected()) {
            stopTimer();
            setIsOpen(false);
        }
    };
    const handleExit = () => {
        setIsOpen(true);
        if (counting) {
            stopTimer();
        }
        if (props.ExitCallback) {
            props.ExitCallback();
        }
    };
    const startTimer = () => {
        setCounting(true);
        setCounter(props.ExitThreshold);
    };
    const stopTimer = () => {
        setCounting(false);
    };
    const isConnected = () => {
        return props.Status === platform_sdk_1.StreamerStatus.Connected;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_modal_1.default, { appElement: document.getElementById('root') || undefined, isOpen: modalIsOpen, onRequestClose: handleCloseModal, className: "Modal", style: modalStyle, contentLabel: "Example Modal" }, isConnected() ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement("h2", null, "Are you still there?"),
                react_1.default.createElement("p", null, `Your session will stop in ${Math.floor(props.ExitThreshold / 60)} minutes.`)),
            react_1.default.createElement("h1", null, new Date(counter * 1000).toISOString().substr(15, 4)),
            react_1.default.createElement("button", { className: "ui primary button inverted left floated", onClick: handleExit }, "End session"),
            react_1.default.createElement("button", { className: "ui primary button right floated", onClick: handleCloseModal }, "Continue"))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h2", null, "Your session has ended"),
            react_1.default.createElement("button", { className: "ui primary button fluid", onClick: () => window.location.reload() }, "Reload")))),
        react_1.default.createElement(react_idle_timer_1.default, { ref: idleTimerRef, onIdle: onIdle, debounce: 250, timeout: props.WarningThreshold * 1000 })));
};
//# sourceMappingURL=IdleTimeout.js.map